import { useFilters } from "../providers/FiltersProvider";
import DatePickerView from "../views/DatePickerView";

export const DatePicker = () => {
  const { setCurrentDate, currentDate } = useFilters();

  return <DatePickerView value={currentDate} onChange={setCurrentDate} />;
};
